class MajorCourseService {
  fetchStudentCourse(major_name, course_name, token) {
    return new Promise(async (resolve, reject) => {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}api/v1/majorCourses/${major_name}/course/${course_name}/fetchStudents`, {
        method: 'GET',
        headers: {
          'token': token,
        },
      })
        .then(data => resolve(data.json()))
        .catch(err => reject(err))
    })
  }

  getMajorCourse(token) {
    return new Promise(async (resolve, reject) => {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}api/v1/majorCourses`, {
        method: 'GET',
        headers: {
          'token': token,
          'Content-Type': 'application/json'
        }
      })
        .then(data => resolve(data.json()))
        .catch(err => reject(err))
    })
  }

  updateMajorCourse(token, id, data) {
    return new Promise(async (resolve, reject) => {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}api/v1/majorCourses/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'token': token
        },
        body: JSON.stringify({...data})})
        .then(data => resolve(data.json()))
        .catch(err => reject(err))
    })
  }

}

export default MajorCourseService;